/**
 * Public (signed-out) API calls: the public-site flag, the read-only listing
 * page and the other-states waitlist. All live under /api/public and need no
 * session, so every call skips the APIAgent 401 → sign-in redirect.
 */

import APIAgent from './apiAgent';

const PUBLIC_OPTIONS = { skipAuthRedirect: true };

/**
 * Whether the public site (landing, public pricing, /homes/:id, waitlist) is
 * switched on for this deployment. Read at runtime so one frontend image can
 * be promoted dev → test → prod with the flag set per backend.
 *
 * Contract — GET /api/public/config
 *   Response 200: { public_site_enabled: boolean }. Never gated.
 *
 * @returns {Promise<{public_site_enabled: boolean}>}
 */
export async function fetchPublicConfig() {
  return APIAgent.request('/api/public/config', 'GET', null, {}, PUBLIC_OPTIONS);
}

/**
 * Fetch the public-safe view of an on-market listing.
 *
 * @param {number|string} houseId
 * @returns {Promise<object>} PublicListing (see backend/app/models/schemas.py).
 *   Rejects with `err.status === 404` when the listing is not public.
 */
export async function fetchPublicListing(houseId) {
  return APIAgent.request(
    `/api/public/listings/${encodeURIComponent(houseId)}`,
    'GET',
    null,
    {},
    PUBLIC_OPTIONS,
  );
}

/**
 * Join the waitlist for a state cutthe6.com does not serve yet.
 *
 * @param {{email: string, state: string, intent: 'buy'|'sell'|'both'}} entry
 * @returns {Promise<{status: string}>}
 */
export async function joinWaitlist({ email, state, intent }) {
  return APIAgent.request(
    '/api/public/waitlist',
    'POST',
    { email, state, intent, source: 'landing' },
    {},
    PUBLIC_OPTIONS,
  );
}

const publicAgent = { fetchPublicConfig, fetchPublicListing, joinWaitlist };

export default publicAgent;
